import { supabase } from '../supabaseClient';

export const fetchServices = async (staffId = null) => {
  let query = supabase.from('services').select('*, profiles:staff_id (full_name)').order('id');
  if (staffId) query = query.eq('staff_id', staffId);

  const { data, error } = await query;
  if (error) {
    alert(`Error loading services: ${error.message}`);
    throw error;
  }
  return data;
};

export const addUpdateService = async (service, serviceId) => {
  const { error } = serviceId
    ? await supabase.from('services').update(service).eq('id', serviceId)
    : await supabase.from('services').insert([service]);

  if (error) {
    alert(`Error saving: ${error.message}`);
    throw error;
  }
  return true;
};

export const deleteService = async (serviceId) => {
  const { error } = await supabase.from('services').delete().eq('id', serviceId);
  if (error) {
    alert(`Error deleting: ${error.message}`);
    throw error;
  }
  return true;
};
